<template>
  <div class="login-container">
    <div class="login-card">
      <div class="card-login-img">
        <img src="../assets/card_login.png" />
      </div>
      <div class="login-form">
        <div>
          <div style="float: right; margin: 2%; margin-bottom: 20px">
            <template>
              <Language></Language>
            </template>
          </div>
        </div>
        <div class="title">{{ $t("login.title") }}</div>
        <el-form ref="loginForm" :model="loginForm" :rules="rules">
          <el-form-item prop="account">
            <el-input class="input" :placeholder="$t('login.accounttip')" size="large" v-model="loginForm.account">
              <span slot="prefix" class="svg-container">
                <svg-icon icon-class="user" />
              </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input @keyup.enter.native="toLogin" class="input" :placeholder="$t('login.passwordtip')" size="large" v-model="loginForm.password" :type="passwordType" ref="password">
              <span slot="prefix" class="svg-container">
                <svg-icon icon-class="lock" />
              </span>
              <span slot="suffix" class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="code-form-item">
              <el-input @keyup.enter.native="toLogin" class="input" :placeholder="$t('login.codetip')" size="large" v-model="loginForm.code">
                <span slot="prefix" class="svg-container">
                  <svg-icon icon-class="safe" />
                </span>
              </el-input>
              <div class="code-img" @click="loadVerifyCode">
                <img :src="codeImg" />
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="login-btn" @click="toLogin">{{ $t("login.loginbt") }}</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getVerifyCode } from "@/api/user"
import Language from "@/components/Languagev"

export default {
  components: {
    Language
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(`${this.$t("login.pwderror")}`))
      } else {
        callback()
      }
    }
    const checkVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(`${this.$t("login.codetip")}`))
      }
      if (value.toLowerCase() !== this.verifyCode.toLowerCase()) {
        callback(new Error(`${this.$t("login.codeerror")}`))
      }
      callback()
    }
    return {
      loginForm: {
        account: "",
        password: "",
        code: ""
      },
      rules: {
        account: [{ required: true, message: this.$t("login.accounttip"), trigger: "blur" }],
        password: [
          // { trigger: 'blur',validator: validatePassword }
        ],
        code: [{ trigger: "blur", validator: checkVerifyCode }]
      },
      tabIndex: 0,
      passwordType: "password",
      codeImg: "",
      verifyCode: ""
    }
  },
  created() {
    //this.rules = ;
    this.loadVerifyCode()
  },
  methods: {
    loadVerifyCode() {
      getVerifyCode().then(({ data }) => {
        this.codeImg = "data:image/jpeg;base64," + data.Image
        this.verifyCode = data.Code
      })
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = ""
      } else {
        this.passwordType = "password"
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    toLogin() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("login.logini"),
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)",
            customClass: "my-loading"
          })
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              //登录成功后加载路由表
              this.$store.dispatch("permission/getRoutes")
              this.$router.push("/home")
            })
            .finally(() => {
              loading.close()
            })
        } else {
        }
      })
    },
    toggleTab(index) {
      this.tabIndex = index
    }
  }
}
</script>
<style scoped lang="scss">
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: url("../assets/bg_login.png") no-repeat;
  background-size: cover;
  background-color: #22b0ff;
}

.login-card {
  width: 1140px;
  height: 590px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  overflow: hidden;
  .card-login-img {
    width: 609px;
    height: 692px;
    margin-top: 0px;
    margin-left: 5px;
  }

  .login-form {
    width: 327px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 30px;
      background: linear-gradient(90deg, #2078fa 0%, #59c1fd 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 500;
      margin-bottom: 40px;
    }

    .svg-container {
      padding-left: 16px;
    }
  }
}

.code-form-item {
  display: flex;

  .code-img {
    width: 130px;
    height: 40px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.login-btn {
  width: 100%;
  height: 52px;
  background: linear-gradient(90deg, #2078fa, #59c1fd);
  border-radius: 100px;
  text-align: center;
  line-height: 52px;
  color: #fff;
  letter-spacing: 8px;
  font-size: 18px;
  margin-top: 30px;
  cursor: pointer;

  &:active {
    opacity: 0.9;
  }
}

img {
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.input >>> .el-input__inner {
  border-radius: 40px;
  padding-left: 50px;
}

.input >>> .el-input__prefix {
  top: 2px;
}

.input >>> .el-input__suffix {
  right: 14px;
  top: 3px;
}
</style>
